import Module from './puppyQuiz'
export default Module
